export const DEFAULT_VECTOR_ASSETS = {
  maplibreJs: "https://unpkg.com/maplibre-gl@5.24.0/dist/maplibre-gl.js",
  maplibreCss: "https://unpkg.com/maplibre-gl@5.24.0/dist/maplibre-gl.css",
  leafletBridgeJs:
    "https://unpkg.com/@maplibre/maplibre-gl-leaflet@0.1.4/leaflet-maplibre-gl.js",
};

let loadPromise = null;

function getVectorAssets() {
  const config =
    typeof window !== "undefined" && window.DwMapConfig
      ? window.DwMapConfig.vectorAssets
      : null;
  return { ...DEFAULT_VECTOR_ASSETS, ...(config || {}) };
}

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.async = false;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`DwMap: failed to load ${src}`));
    document.head.appendChild(script);
  });
}

function loadStylesheet(href) {
  if (document.querySelector(`link[rel="stylesheet"][href="${href}"]`)) {
    return;
  }
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  document.head.appendChild(link);
}

export function isWebGLSupported() {
  try {
    const canvas = document.createElement("canvas");
    return !!(canvas.getContext("webgl2") || canvas.getContext("webgl"));
  } catch (e) {
    return false;
  }
}

/**
 * Loads MapLibre GL JS and the Leaflet bridge once per page.
 * Resolves when L.maplibreGL is available.
 */
export function loadVectorTileSupport() {
  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = (async () => {
    if (!isWebGLSupported()) {
      throw new Error("DwMap: WebGL is not supported in this browser");
    }

    const assets = getVectorAssets();
    loadStylesheet(assets.maplibreCss);

    if (typeof window.maplibregl === "undefined") {
      await loadScript(assets.maplibreJs);
    }
    if (typeof L.maplibreGL !== "function") {
      await loadScript(assets.leafletBridgeJs);
    }
    if (typeof L.maplibreGL !== "function") {
      throw new Error("DwMap: L.maplibreGL is not available after loading");
    }
  })();

  loadPromise.catch(() => {
    loadPromise = null;
  });

  return loadPromise;
}
